/** Display value for a stored form field answer (JSONB + optional file key). */
export function formatFormSubmissionFieldValue(
  fieldType: string,
  value: unknown,
  fileKey: string | null,
): string {
  if (fieldType === "file") {
    if (fileKey) return fileKey;
    if (typeof value === "string" && value) return value;
    return "—";
  }
  if (value === null || value === undefined) return "—";
  if (typeof value === "boolean") return value ? "ແມ່ນ" : "ບໍ່";
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
